export const pageHeaderStyles = {
	display: 'flex',
	padding: '20px 24px',
	alignItems: 'center',
	gap: '16px',
	alignSelf: 'stretch',
	justifyContent: 'space-between',
	borderBottom: '1px solid',
	borderColor: 'rgba(0, 0, 0, 0.08)',
	'@media (max-width: 768px)': {
		display: 'none',
	},
};
export const pageHeaderInContainerStyles = {
	display: 'flex',
	padding: 0,
	alignItems: 'center',
	justifyContent: 'space-between',
	alignSelf: 'stretch',
	width: '100%',
};
export const pageHeaderIconStyles = {
	display: 'flex',
	width: '40px',
	height: '40px',
	justifyContent: 'center',
	alignItems: 'center',
	borderRadius: '9px',
	background: 'rgba(122, 121, 119, 0.08)',
	marginRight: '8px',
};
export const pageHeaderText = {
	flexGrow: 1,
	flexShrink: 0,
	flexBasis: 0,
};
